import {SHType} from "../common/SHType";

export enum PfileTypeId {
    Unknown = 1,
    AdminDashOHLogo = 2,
    PlayerPoster = 51,
    ListPoster = 101,
    ListThumb = 102,
    ListPoster2x3 = 103,
    HeroBg = 104,
    TitleLogo = 105,
    AppWebBG = 501,
    AppWebOHLogo = 502,
    AppWebOHBG = 503,
    AppWebSiteImg = 504,
    AppWebIcon48 = 505,
    AppWebIcon192 = 506,
    AppWebIconAppletouch180 = 507,
    AppRokuBG = 601,
    AppRokuOHLogo = 602,
    AppRokuOHBG = 603,
    AppRokuSplashFHD = 604,
    AppRokuSplashHD = 605,
    AppRokuSplashSD = 606,
    AppRokuApplogoFHD = 607,
    AppRokuApplogoHD = 608,
    AppRokuAppLogoSD = 609
}

class _PFileType extends SHType<PfileTypeId> {
    constructor() {
        super(
            "PFileType",
            [
                [PfileTypeId.Unknown, "unknown_file_type"],
                [PfileTypeId.AdminDashOHLogo, "admin_dash_oh_logo"],
                [PfileTypeId.PlayerPoster, "player_poster"],
                [PfileTypeId.ListPoster, "list_poster"],
                [PfileTypeId.ListThumb, "list_thumb"],
                [PfileTypeId.ListPoster2x3, "list_poster_2x3"],
                [PfileTypeId.HeroBg, "hero_bg"],
                [PfileTypeId.TitleLogo, "title_logo"],
                [PfileTypeId.AppWebBG, "app_web_bg"],
                [PfileTypeId.AppWebOHLogo, "app_web_oh_logo"],
                [PfileTypeId.AppWebOHBG, "app_web_oh_bg"],
                [PfileTypeId.AppWebSiteImg, "app_web_site_img"],
                [PfileTypeId.AppWebIcon48, "app_web_icon_48"],
                [PfileTypeId.AppWebIcon192, "app_web_icon_192"],
                [PfileTypeId.AppWebIconAppletouch180, "app_web_icon_appletouch_180"],
                [PfileTypeId.AppRokuBG, "app_roku_bg"],
                [PfileTypeId.AppRokuOHLogo, "app_roku_oh_logo"],
                [PfileTypeId.AppRokuOHBG, "app_roku_oh_bg"],
                [PfileTypeId.AppRokuSplashFHD, "app_roku_splash_fhd"],
                [PfileTypeId.AppRokuSplashHD, "app_roku_splash_hd"],
                [PfileTypeId.AppRokuSplashSD, "app_roku_splash_sd"],
                [PfileTypeId.AppRokuApplogoFHD, "app_roku_applogo_fhd"],
                [PfileTypeId.AppRokuApplogoHD, "app_roku_applogo_hd"],
                [PfileTypeId.AppRokuAppLogoSD, "app_roku_applogo_sd"]
            ]
        );
    }

}

//added suffix "Obj" to avoid conflict with legacy MediaStateType enum
export const PFileType = new _PFileType();

/**
 * Returns a human-readable label for a given PfileTypeId.
 * @param fileTypeIdValue The PfileTypeId value (or a number).
 * @returns A string label for the file type.
 */
export function getPfileTypeLabel(fileTypeIdValue: PfileTypeId): string {
    switch (fileTypeIdValue) {
        case PfileTypeId.Unknown:
            return "Unknown File Type";
        case PfileTypeId.AdminDashOHLogo:
            return "Admin Dashboard OH Logo";
        case PfileTypeId.PlayerPoster:
            return "Player Poster";
        case PfileTypeId.ListPoster:
            return "List Poster";
        case PfileTypeId.ListThumb:
            return "List Thumbnail";
        case PfileTypeId.ListPoster2x3:
            return "List Poster 2:3";
        case PfileTypeId.HeroBg:
            return "Hero Background";
        case PfileTypeId.TitleLogo:
            return "Title Logo";
        case PfileTypeId.AppWebBG:
            return "App Web Background";
        case PfileTypeId.AppWebOHLogo:
            return "App Web OH Logo";
        case PfileTypeId.AppWebOHBG:
            return "App Web OH Background";
        case PfileTypeId.AppWebSiteImg:
            return "App Website Image";
        case PfileTypeId.AppWebIcon48:
            return "App Web Icon 48x48";
        case PfileTypeId.AppWebIcon192:
            return "App Web Icon 192x192";
        case PfileTypeId.AppWebIconAppletouch180:
            return "App Web Apple Touch Icon 180x180";
        case PfileTypeId.AppRokuBG:
            return "App Roku Background";
        case PfileTypeId.AppRokuOHLogo:
            return "App Roku OH Logo";
        case PfileTypeId.AppRokuOHBG:
            return "App Roku OH Background";
        case PfileTypeId.AppRokuSplashFHD:
            return "App Roku Splash FHD";
        case PfileTypeId.AppRokuSplashHD:
            return "App Roku Splash HD";
        case PfileTypeId.AppRokuSplashSD:
            return "App Roku Splash SD";
        case PfileTypeId.AppRokuApplogoFHD:
            return "App Roku App Logo FHD";
        case PfileTypeId.AppRokuApplogoHD:
            return "App Roku App Logo HD";
        case PfileTypeId.AppRokuAppLogoSD:
            return "App Roku App Logo SD";
        default:
            // Handle any number not matching an enum value
            return `Unknown File (${fileTypeIdValue})`;
    }
}
